<template>
  <i>
    <slot></slot>
  </i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      require: true
    }
  }
}
</script>

<style scoped>
  i {
    font-family: "Unistra Symbol", sans-serif;
    font-size: 25px;
    text-decoration: none;
    color: black;
    font-style: normal;
    line-height: 100%;
  }
</style>
